import logoBackground from 'assets/logo-orange-angle.svg'
import { makeStyles } from '@material-ui/styles'

import { Theme } from 'styling/theme'

export const useStyles = makeStyles((theme: Theme) => ({
    scrollIndicator: { background: 0, border: 0 },
    shadowEffect: {},
    paywallWrapper: {
        background: theme.colors.white,
        top: 0,
        position: 'absolute',
        bottom: '0',
        width: '100%',
        padding: '20px 16px',
        textAlign: 'center',
        zIndex: theme.zIndexLevels.five,
        minHeight: 580,

        '& $scrollIndicator, $shadowEffect': {
            display: 'block',
            position: 'fixed',
            bottom: 0,
            opacity: 0,
            zIndex: 3,
            transform: 'translateX(138px)',
            transition: 'opacity ease .2s',
            pointerEvents: 'none',
        },
        '& $shadowEffect': {
            right: '50%',
            transform: 'translate(50%, 20px)',
        },
    },
    scrollIndicatorVisible: {
        '& $scrollIndicator, $shadowEffect': {
            opacity: 1,
            pointerEvents: 'all',
        },
    },
    soldOut: {
        filter: 'grayscale(1)',
    },
    submitPassBtn: {
        height: '42px !important',
        minHeight: '42px',

        '& div': {
            height: 'auto !important',
        },
    },
    enterCodeBtn: {
        border: `solid 1px ${theme.colors.light.grey}`,
    },
    '@media (min-width: 768px)': {
        paywallWrapper: {
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
    },
    '@media (max-width: 767px)': {
        shadowEffect: {
            pointerEvents: 'none',
            height: '20px',
            width: '100vw',
            background: 'transparent',
            boxShadow: '0 -20px 50px rgba(255, 152, 0, .8)',
            transform: 'translate(50%, 20px)',
        },
        scrollIndicator: {
            transform: 'translate(50%, -17px)',
            background: 0,
            border: 0,
        },
        paywallWrapper: {
            padding: '40px 16px 20px',
        },
    },
    showCard: {
        display: 'flex',
        width: '100%',
        position: 'relative',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.35)',
        marginBottom: 32,

        '&::before,&::after': {
            content: '""',
            display: 'block',
            height: 117,
            width: '100%',
            position: 'absolute',
        },

        '&::before': {
            backgroundImage: 'linear-gradient(#f9ac18, #f77731)',
        },

        '&::after': {
            backgroundImage: `url(${logoBackground})`,
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
            borderBottom: '6px solid rgba(255, 255, 255, .7)',
            backgroundClip: 'border-box',
            zIndex: 1,
        },
    },
    showCardContent: {
        zIndex: 2,
        padding: '50px 24px 0',
        height: '100%',
        width: '100%',

        '&::before, &::after': {
            content: '""',
            display: 'inline-block',
            height: 40,
            width: 21,
            position: 'absolute',
            bottom: 20,
            background: 'white',
        },
        '&::after': {
            left: -2,
            boxShadow: 'inset -2px 0px 3px rgba(0, 0, 0, .2)',
            borderTopRightRadius: 21,
            borderBottomRightRadius: 21,
        },
        '&::before': {
            right: -2,
            boxShadow: 'inset 2px 0px 3px rgba(0, 0, 0, .2)',
            borderTopLeftRadius: 21,
            borderBottomLeftRadius: 21,
        },
    },
    showCardBorder: {
        height: 6,
        width: '100%',
        position: 'absolute',
        bottom: 0,
        opacity: 0.6,
        backgroundImage: theme.gradients.yellowToPink,
    },
    showTitle: {
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
    },
    title: {
        backgroundImage: theme.gradients.yellowToPink,
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: '1.57px',
        textAlign: 'center',
        '-webkit-background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
        backgroundClip: 'text',
        textTransform: 'uppercase',
        marginBottom: 16,
    },
    showDate: {
        display: 'flex',
        justifyContent: 'space-between',
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        fontSize: 12,
        padding: '0 32px',
        color: theme.colors.light.darkgrey,

        '@media (min-width: 768px) and (max-width: 1023px)': {
            padding: '0 16px',
        },
    },
    showLocation: { justifyContent: 'center', lineHeight: '24px' },
    watchButton: {
        marginLeft: 'auto',
        height: 32,
        width: '100%',
    },
    img: {
        width: 120,
        height: 120,
        marginBottom: 24,
        objectFit: 'cover',
        borderRadius: 8,
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.5)',
    },
    separator: {
        margin: '20px 0',
    },
    buttonsWrapper: {
        paddingBottom: 20,
        '@media (min-width: 768px) ': {
            paddingBottom: 0,
        },
    },
}))
